module.exports = __webpack_public_path__ + "static/img/04-low-gain.5604549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp/04-low-gain.jpg
// module id = gCAY
// module chunks = 12